// extracted by mini-css-extract-plugin
export default {"melodyVideo":"eQ-z","isFullWidth":"fQ-z","landingPageVideo":"gQ-z","play":"hQ-z","iframeVideo":"iQ-z","playHidden":"jQ-z","fullwidth":"kQ-z"};